import styled, { css } from 'styled-components'
import { Media } from '@raysync/common/theme'

export const ArticleContainer = styled.article`
  ${({ theme: { color, typography, spacing } }) => css`
    width: 100%;
    color: ${color.panel};
    border: 1px solid transparent;
    font-size: ${typography.textSmall};
    word-break: break-all;
    padding: 8px 30px 0px 34px;
    min-height: 100vh;
    background: #fff;
    scroll-behavior: smooth;
    ${Media.phone`
      padding: .3rem .3rem .2rem;
      min-height: unset;
    `}
    span.update-time {
      display:block;
      color: ${color.text};
      font-size: ${typography.textThin};
      margin-top: 8px;
      margin-bottom: 8px;
    }
    h1,
    h2,
    h3,
    h4,
    h5 {
      color: ${color.primary};
      margin-bottom: ${spacing.small};
    }
    h1 {
      font-size: 24px;
      font-weight: 500;
    }
    h2,h3{
      font-size: 20px;
      font-weight: 500;
    }
    button {
      cursor: pointer;
      text-decoration: none;
      height: 36px;
      line-height: 36px;
      padding: 0 22px;
      position: relative;
      display: inline-block;
      text-align: center;
      touch-action: manipulation;
      white-space: nowrap;
      user-select: none;
      border-radius: 6px;
      color: white;
      background-size: 300% 100%;
      border: 0 solid transparent;
      background-color: ${color.secondary};
      transition: all 0.3s linear;
      :hover {
        background-position: 100% 0;
        background-color: #dd501b;
      }
    }
    code{
      padding: 2px 4px;
      color: #c0341d;
      background-color: #fbe5e1;
      border-radius: 4px;
    }
    strong {
      display: inline-block;
      /* color: ${color.primary}; */
      color: #2d2f31;
      font-size: ${typography.textSmall};
      margin-bottom: ${spacing.small};
    }

    hr {
      background-color: ${color.divider};
    }
    a {
      color: #4a90e2;
      font-weight: bold;
      text-decoration: underline;
      line-height: 1.2;
    }
    li,
    p {
      color: ${color.primary};
      margin-bottom: ${spacing.small};
      word-break: break-word;
    }
    img {
      margin-top: ${spacing.small};
      margin-bottom: ${spacing.small};
      max-width: 100%;
      display: block;
      border: 1px solid #e7ebef;
    }
    video {
      max-width: 100%;
      border: none;
      margin: 10px 0;
      ${Media.phone`
        height: initial;
      `}
    }
    pre {
      overflow-x: auto;
    }
    table {
      color: ${color.primary};
      margin: 1em 0;
      width: 100%;
      overflow: hidden;
      border: 0;
    }
    tr {
      border: 1px solid ${color.panel};
      :nth-of-type(odd) {
        background-color: #f1f1f1;
      }
    }
    td {
      word-wrap: break-word;
      max-width: 7em;
      border: 1px solid ${color.textLight};
      padding: 5px;
    }
    th {
      border: 1px solid ${color.textLight};
      background-color: ${color.textLight};
      color: #fff;
      padding: 1em;
    }
    th td {
      text-align: center;
    }
    ul,ol {
     padding-left: 16px;
    }
`}
`
export const NavigationWrap = styled.div`
  width: 250px;
  min-width: 250px;
  position: relative;
  /* overflow-y: scroll; */
  border-left: 1px solid #ddd;
  ${Media.phone`
    display: none;
    border: none;
  `}
`
export const NavigationBox = styled.div`
  width: 100%;
  position: sticky;
  top: 60px;
  right: 0px;
  padding: 22px 0 0 34px;
  h4 {
    font-weight: bold;
    font-size: 14px;
  }
  ul {
    max-height: 80vh;
    overflow-y: auto;
    list-style: none;
    padding-left: 0;
    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 5px;
    }
    ::-webkit-scrollbar-thumb {
      background: #ddd;
      border-radius: 5px;
    }
    li {
      margin-bottom: 10px;
    }
  }
`
export const HeaderItem = styled.a`
  font-size: 14px;
  text-decoration: none !important;
  color: ${p => (p.actived ? p.theme.color.secondary : '#636772')} !important;
`
export const ArticleWrap = styled.div`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #ddd;
  margin-top: 20px;
  width: 1100px;
  ${Media.phone`
    width: unset;
    border: none;
    margin-top: .2rem;
  `}
`
export const ArticleContent = styled.div`
  min-width: 800px;
  padding: 20px 20px 200px 0;
  min-height: 90vh;
  ${Media.phone`
    border: none;
    padding: 0;
    min-width: unset;
    min-height: unset;
  `}
`
